import React from 'react'
import { useTranslation } from 'react-i18next'
import RightContact from './RightContact'
import LeftContact from './LeftContact'

const Contact = () => {
   const {t} = useTranslation()
  return (
    <div className=' '>
<div className="pt-3 max-w-6xl max-lg:max-w-3xl mx-auto  rounded-lg ">
  <div className="grid contact  lg:grid-cols-2 items-center gap-14 sm:p-8 p-4 font-[sans-serif]">
    <RightContact/>
    <LeftContact/>

  </div>
</div>
    </div>
  )
}

export default Contact
